import LandingPage from "./LandingPage";
import { assessmentContent } from "./content/assessment";

export default function AssessmentPage() {
  return <LandingPage content={assessmentContent} />;
}
